import { Method } from "axios";
import { BaseRequest } from "./base-request";
import { DrugModelDetail } from "../models/response/drug-model-detail";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

export class DrugModelDetailRequest extends BaseRequest
{
    protected modelId: string;

    public constructor(modelId: string)
    {
        super();

        this.modelId = modelId;
    }

    protected getMethod(): Method
    {
        return "GET";
    }

    protected getUri(): string
    {
        return `/drugmodels/${this.modelId}`;
    }

    protected populateResponse(elem: XmlElementWrapper): DrugModelDetail
    {
        return DrugModelDetail.makeFromXml(elem);
    }
}
